import Admin from './admin';
import AILabIndex from './ai-lab';
import AICatalogContainer from './ai-lab/catalog/AICatalogContainer';
import AIDesignerContainer from './ai-lab/designer/AIDesignerContainer';
import CcpaScrub from './admin/CcpaScrub';
import ClaimDetails from './claim-details';
import ClaimsList from './claims-list/';
import CompanyDetail from './admin/CompanyDetail'; 
import Companies from './admin/CompanySearch';
import CompanyFileTypes from './admin/CompanyFileTypes';
import Contacts from './admin/ContactsSearch';
import ContactDetail from './admin/ContactDetail';
import Dashboard from './dashboards'; 
import DocumentTypes from './admin/DocumentTypes';
import Financials from './financials';
import NotFound from './app/NotFound';
import Payroll from './payroll'; 
import Reports from './reports';
import Security from './security';
import Queues from './queues';
import Unauthorized from './app/Unauthorized';

export default {
    Admin,
    AILabIndex, 
    AICatalogContainer,
    AIDesignerContainer,
    CcpaScrub, 
    ClaimDetails,  
    ClaimsList,
    Queues,
    Contacts, 
    CompanyDetail, 
    Companies,
    CompanyFileTypes,
    ContactDetail,
    Dashboard,
    DocumentTypes, 
    Financials,
    NotFound, 
    Payroll, 
    Reports,  
    Security,
    Unauthorized
};